export default "__VITE_ASSET__Cl0JRbYm__"